import CLeftSideBar from 'components/LeftSideBar/LeftSideBar'
import CMidHead from 'components/MidHead/MidHead'
import CModalMessage from 'components/modal-message/ModalMessage'
import CTimerModal from 'components/timer-modal/Index.vue'
export default {
  CLeftSideBar,
  CMidHead,
  CModalMessage,
  CTimerModal,
}
